import { render, staticRenderFns } from "./BlurCard.vue?vue&type=template&id=53a4b838&scoped=true"
import script from "./BlurCard.vue?vue&type=script&lang=js"
export * from "./BlurCard.vue?vue&type=script&lang=js"
import style0 from "./BlurCard.vue?vue&type=style&index=0&id=53a4b838&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4b838",
  null
  
)

export default component.exports